import React from "react";
import { motion } from "framer-motion";
import { animateSection } from "../utils/animateSection";
import data from "../data/skills.json";

const coreSkills = data.coreTechnicalSkills;
const otherSkills = data.additionalSkills.mlAiSkills;
const tools = data.additionalSkills.toolsAndLibraries;

const cardVariants = (percent) => {
  return {
    offscreen: {
      width: 0,
    },
    onscreen: {
      width: `${percent}%`,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };
};

function Skills() {
  return (
    <section
      id="skills"
      className="py-[40px] sm:py-[60px] max-w-[1100px] text-white/25 flex flex-col justify-center mx-auto font-sfMonoRegular overflow-x-hidden"
    >
      {/* Heading */}
      <div className="about-heading w-fit flex flex-row mt-[10px] mb-[40px]">
        <div className="text-theme-green flex items-center text-[15px] sm:text-[20px]">
          02.&nbsp;
        </div>
        <h1 className="text-theme-gray-light ml-[10px] text-[26px] sm:text-[32px] font-calibreSemiBold fontFix">
          My Skills
        </h1>
      </div>

      {/* Skills Section */}
      <div className="flex flex-col md:flex-row justify-center md:justify-between items-center md:items-start gap-12 text-[20px] font-calibreRegular text-theme-gray-deep font-medium">
        {/* Core Skills */}
        <div className="w-full max-w-[400px]">
          <h1 className="text-theme-gray-light font-sfMonoRegular mb-10">
            Core Technical Skills
          </h1>
          <div className="font-calibreRegular text-2xl text-theme-green">
            {coreSkills.map((skill) => (
              <div key={skill.name}>
                <div className="flex justify-between">
                  <div>{skill.name}</div>
                  <div className="text-theme-green/75">{skill.percent}%</div>
                </div>
                <motion.div
                  className="card-container"
                  initial="offscreen"
                  whileInView="onscreen"
                  viewport={{ once: false, amount: 0.8 }}
                >
                  <div className="bar w-full h-4 bg-theme-lightest-navy mb-8 rounded">
                    <motion.div
                      className="bar-fill h-full bg-theme-green rounded"
                      variants={cardVariants(skill.percent)}
                    ></motion.div>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>

        {/* ML Skills */}
        <div className="w-full max-w-[400px]">
          <h1 className="text-theme-gray-light font-sfMonoRegular mb-10">
            ML Skills
          </h1>
          <div className="font-calibreRegular text-2xl text-theme-green">
            {otherSkills.map((skill) => (
              <div key={skill.name}>
                <div className="flex justify-between">
                  <div>{skill.name}</div>
                  <div className="text-theme-green/75">{skill.percent}%</div>
                </div>
                <motion.div
                  className="card-container"
                  initial="offscreen"
                  whileInView="onscreen"
                  viewport={{ once: false, amount: 0.8 }}
                >
                  <div className="bar w-full h-4 bg-theme-lightest-navy mb-8 rounded">
                    <motion.div
                      className="bar-fill h-full bg-theme-green rounded"
                      variants={cardVariants(skill.percent)}
                    ></motion.div>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>

        {/* Tools */}
        <div className="w-full max-w-[400px]">
          <h1 className="text-theme-gray-light font-sfMonoRegular mb-10">
            Tools
          </h1>
          <div className="font-calibreRegular text-2xl text-theme-green">
            {tools.map((skill) => (
              <div key={skill.name}>
                <div className="flex justify-between">
                  <div>{skill.name}</div>
                  <div className="text-theme-green/75">{skill.percent}%</div>
                </div>
                <motion.div
                  className="card-container"
                  initial="offscreen"
                  whileInView="onscreen"
                  viewport={{ once: false, amount: 0.8 }}
                >
                  <div className="bar w-full h-4 bg-theme-lightest-navy mb-8 rounded">
                    <motion.div
                      className="bar-fill h-full bg-theme-green rounded"
                      variants={cardVariants(skill.percent)}
                    ></motion.div>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function animatedSection() {
  return animateSection(Skills);
}

export default animatedSection;
